import React from 'react'
import { HeroImageProps } from './types'

export const HeroImage = ({
  receiverName,
  receiverProfilePicture,
  receiverUrl,
  linked,
}: HeroImageProps): JSX.Element => (
  <div className={`donations-new-hero-image text-xl`}>
    <img src={receiverProfilePicture} alt="" />
    {linked ? (
      <a className="text-3xl" href={receiverUrl}>
        {receiverName}
      </a>
    ) : (
      <span>{receiverName}</span>
    )}
  </div>
)
